module.exports = __webpack_public_path__ + "static/media/landingService4.f57846dd.png";